import { panelSnapshotPosts } from './PanelSnapshotPosts';

const tickerSnapshot = {
    id: 'cGFuZWw6NWQ4ZDExNDdjYmU5OTMwZTE3OGQ3M2Zi',
    partnerId: 349,
    clientId: 7101,
    name: 'Ticker',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4ZDExNDdjYmU5OTMwZTE3OGQ3M2Zh',
        name: 'Scene 24',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'ticker',
                type: 'postsTicker',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 6,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'rotate',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        postOuter: {
                            default: 'm-1',
                        },
                        metaGroup: {
                            default: 'p-reset w-100',
                        },
                        userGroup: {
                            default: 'p-0 pb-1',
                        },
                        postText: {
                            default: 'ta-l p-reset p-0',
                        },
                        lineClampVerticalAlign: {
                            default: 'top',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: false,
                    showImageStyles: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    postImageTextFormat: 'clamp',
                    postImageTeleprompterSpeed: 50,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 3,
                    imageTextColor: '',
                    imageBackgroundSize: 'cover',
                    imagePostHideText: false,
                    imageFaceDetection: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 12,
                    textOnlyColor: '',
                    textOnlyTextFormat: 'clamp',
                    textOnlyTeleprompterSpeed: 50,
                    showUserGroup: true,
                    postLineClamp: true,
                    postLineClampValue: 3,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 9,
                    userGroupNameSize: 13,
                    userGroupScreenNameSize: 11,
                    socialIconPosition: {
                        x: 'left',
                        y: 'top',
                    },
                    showText: true,
                    showTimeStamp: true,
                    timeStampSize: 11,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textFitMin: 20,
                    activePostsInWindow: 1,
                    stripLinks: true,
                    blastDelimiter: 'words',
                    metaThemePalette: [],
                    showSecondaryImageOverlay: false,
                    showZeroEngagementValues: false,
                    metaOffsetTotal: 8,
                    themeOffsetTotal: 2,
                    imageFiltersOpen: true,
                    postLayoutType: 'd',
                    postTextOnlySize: 15,
                    postImageTextSize: 15,
                    postLayoutOrientation: 'horizontal',
                    showIconInUserGroup: true,
                    textOnlyBackgroundColor: '',
                    imagePostBackgroundColor: '',
                    secondaryOverlayColor: '',
                    engagementMetricsPosition: 'top_right',
                    maxCharacters: 400,
                    userGroupLayoutType: 'a',
                    postCompositionType: 'a',
                    userGroupAvatarSize: 15,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                        baseline: {
                            engagementMetricsSize: 12,
                            postLineClampValue: 3,
                            userGroupIconSize: 9,
                            userGroupNameSize: 13,
                            userGroupScreenNameSize: 11,
                            timeStampSize: 11,
                            textFitMin: 20,
                            postTextOnlySize: 15,
                            postImageTextSize: 15,
                            userGroupAvatarSize: 15,
                        },
                        optionDefaults: {
                            classOverrides: {
                                postOuter: {
                                    default: 'm-1',
                                },
                                metaGroup: {
                                    default: 'p-reset w-100',
                                },
                                userGroup: {
                                    default: 'p-0 pb-1',
                                },
                                postText: {
                                    default: 'ta-l p-reset p-0',
                                },
                                lineClampVerticalAlign: {
                                    default: 'top',
                                },
                            },
                        },
                        breakpoints: {
                            xs: {
                                options: {
                                    classOverrides: {
                                        postOuter: {
                                            default: 'm-0',
                                        },
                                        userGroup: {
                                            default: 'p-0 pb-025',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    classOverrides: {
                                        postOuter: {
                                            default: 'm-025',
                                        },
                                        userGroup: {
                                            default: 'p-0 pb-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-05',
                                        },
                                    },
                                },
                            },
                            m: {
                                options: {
                                    classOverrides: {
                                        postOuter: {
                                            default: 'm-05',
                                        },
                                        userGroup: {
                                            default: 'p-0 pb-05',
                                        },
                                        engagementMetric: {
                                            default: 'm-reset ml-1',
                                        },
                                    },
                                },
                            },
                        },
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    source: 'REPORTING',
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    pageSize: '3',
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH_COUNT',
                                        },
                                    ],
                                    includeComments: false,
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1569481200000,
                                        endTime: 1569567599999,
                                    },
                                    filters: [
                                        {
                                            dimensionName: 'TOPIC_GROUP_IDS',
                                            filterType: 'IN',
                                            values: ['5a00b9e4e4b082264ab84227'],
                                        },
                                    ],
                                    showInReplyToPost: false,
                                    projections: [],
                                    groupBys: [],
                                },
                                options: {
                                    count: 200,
                                    imagePreload: false,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176537936575258627',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569343477754,
                                        permalink:
                                            'https://twitter.com/show/status/1176537936575258627',
                                        message:
                                            "In honor of Sprinklr's 10th birthday today, I'm also celebrating the 10lbs I lost from riding my bike to work! #sprinklr10 #sprinklrlife #bikelife https://t.co/dKrY1ueh6M https://t.co/yR4b3ShAwt",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [147, 170],
                                                    url: 'https://t.co/dKrY1ueh6M',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [171, 194],
                                                    url: 'https://t.co/yR4b3ShAwt',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [111, 122],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [123, 136],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [137, 146],
                                                    hashtag: 'bikelife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png',
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Austin, Texas, United States',
                                            lat: 30.26715,
                                            lon: -97.74306,
                                            additional: {
                                                country: 'United States',
                                                state: 'Texas',
                                                code: 'US',
                                                state_code: 'TX',
                                                city: 'Austin',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[2].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 194,
                                            numRetweets: 1,
                                            reachCount: 41730,
                                            numLikes: 17,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 83,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 17,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176342792685019136',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569296951825,
                                        permalink:
                                            'https://twitter.com/show/status/1176342792685019136',
                                        message:
                                            'Time to fly into a new decade! 😂😂 ✈️ #Sprinklr10 #SprinklrLife \n\nHappy Birthday @Sprinklr! https://t.co/NtbSzu2sNQ',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [82, 91],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [93, 116],
                                                    url: 'https://t.co/NtbSzu2sNQ',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [39, 50],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [51, 64],
                                                    hashtag: 'SprinklrLife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'India',
                                            gender: 'M',
                                            snId: '206077671',
                                            name: 'Akshit Dhumal',
                                            screenName: 'akshitdhumal',
                                            email: null,
                                            bio:
                                                'Whatever you do, don’t be another brick in the wall!',
                                            following: 1710,
                                            followers: 822,
                                            favCount: 1336,
                                            statusCount: 2252,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/akshitdhumal',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1175464468802703360/eNKo60Tp_normal.jpg',
                                            createdTime: 1287730322000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '54368820e4b093569d4cbe68',
                                            participationIndex: 0,
                                            influencerIndex: 55,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Bengaluru South, India',
                                            lat: 20,
                                            lon: 77,
                                            additional: {
                                                country: 'India',
                                                code: 'IN',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[6].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 116,
                                            numRetweets: 3,
                                            reachCount: 39126,
                                            numLikes: 10,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 822,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 10,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {
                                            eS: [
                                                {
                                                    title: 'Company',
                                                    pol: 'neutral',
                                                    sc: 1,
                                                    labels: ['time'],
                                                },
                                            ],
                                        },
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176569974053330945',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569351116084,
                                        permalink:
                                            'https://twitter.com/show/status/1176569974053330945',
                                        message:
                                            'Home office celebrations for #Sprinklr10 in full effect with my Administrative Assistant, Vincenzo 🥳 @Sprinklr #SprinklrLife https://t.co/HR2bEdgfun',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [102, 111],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [126, 149],
                                                    url: 'https://t.co/HR2bEdgfun',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [29, 40],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [112, 125],
                                                    hashtag: 'SprinklrLife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: '',
                                            gender: null,
                                            snId: '1110586199947792384',
                                            name: 'Janelle Panuccio',
                                            screenName: 'JanellePanuccio',
                                            email: null,
                                            bio: 'Account Executive @Sprinklr  #SprinklrLife',
                                            following: 92,
                                            followers: 34,
                                            favCount: 135,
                                            statusCount: 61,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/JanellePanuccio',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=https://pbs.twimg.com/profile_images/1154086173876391937/yyRxkV_9_normal.jpg',
                                            createdTime: 1553619358000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5c9e8156e4b0f0b88c295159',
                                            participationIndex: 0,
                                            influencerIndex: 0,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Colonial Park, PA',
                                            lat: 0,
                                            lon: 0,
                                            additional: {
                                                country: 'United States',
                                                code: 'US',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[7].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 149,
                                            numRetweets: 2,
                                            reachCount: 35954,
                                            numLikes: 15,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 34,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 15,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'ordered',
                            options: {
                                fixedList: 3,
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '2.08%',
                    right: null,
                    top: '3.72%',
                    bottom: null,
                    width: '95.84%',
                    height: '92.56%',
                    portrait: {
                        left: '3%',
                        top: '2%',
                        width: '94%',
                        height: '96%',
                    },
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Ticker',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_ticker',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569526116815,
};
export default tickerSnapshot;
